import { userProfileSelector, usernameSelector } from 'redux/user/selectors';
import { brandSelector } from 'redux/ui/selectors';

import { currentTenantSelector } from 'features/authentication';

import addBeforeNotify from './addBeforeNotify';

function beforeNotify(payload, getStore) {
  // Report current user to Bugsnag, if available
  const store = getStore();
  const currentState = store && store.getState();

  if (currentState) {
    let userForBugsnag = {
      username: usernameSelector(currentState),
      tenant: currentTenantSelector(currentState),
      brand: brandSelector(currentState),
    };

    const userProfile = userProfileSelector(currentState);
    if (userProfile) {
      userForBugsnag = {
        ...userForBugsnag,
        ...userProfile.toJS(),
      };
    }

    // eslint-disable-next-line no-param-reassign
    payload.user = userForBugsnag;
  } else {
    console.log('Bugsnag user beforeNotify - no Redux store available yet');
  }
}

function setup(Bugsnag) {
  addBeforeNotify(Bugsnag, beforeNotify);
}

export default { setup };



// WEBPACK FOOTER //
// ./setup/Bugsnag/user.js